import { render, staticRenderFns } from "./TheNav.vue?vue&type=template&id=54fa5db4&scoped=true&"
import script from "./TheNav.vue?vue&type=script&lang=js&"
export * from "./TheNav.vue?vue&type=script&lang=js&"
import style0 from "./TheNav.vue?vue&type=style&index=0&id=54fa5db4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa5db4",
  null
  
)

export default component.exports